import React from 'react'

import cx from 'classnames'

import { CircleLoader, Colorway } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import { ReactComponent as EmptyStateIcon } from '../../svgs/empty-state-icon.svg'

import utilityStyles from '../../styles/utility.module.css'
import styles from './styles.module.css'

interface Props {
  mainText: React.ReactNode
  subText?: React.ReactNode
  component?: React.ReactNode
  colorway?: {
    type: string
    icon: string
  }
  icon?: React.ReactNode
  'data-ocweb-id'?: string
  className?: string
}

export const FlexibleState: React.FC<Props> = ({
  mainText,
  subText,
  component,
  colorway,
  icon,
  className,
  'data-ocweb-id': dataTestId
}) => {
  const renderedIcon = colorway ? (
    <Colorway type={colorway.type} size="medium">
      <Icon name={colorway.icon} width={80} height={80} />
    </Colorway>
  ) : (
    icon
  )

  return (
    <div data-ocweb-id={dataTestId} className={cx(styles.flexibleState)}>
      <div className={cx(styles.flexibleContainer)}>
        <div className={cx(styles.mainContainer, className)}>
          <div className={cx(styles.SvgStyle)}>{renderedIcon}</div>
          <div className={cx(styles.mainText, utilityStyles.semiBoldWeight)}>{mainText}</div>
          {subText && <div className={cx(styles.subtext)}>{subText}</div>}
          {component}
        </div>
      </div>
    </div>
  )
}

export const driftErrorStateBuilder = (errorString: string, subText?: string) => () => (
  <FlexibleState
    data-ocweb-id={'loading-error'}
    mainText={`We’re having trouble grabbing ${errorString}`}
    colorway={{ type: '1', icon: 'dizzybot-error' }}
    className={styles.driftError}
    subText={subText || 'Reload the page to try again.'}
  />
)

export const driftLoadingStateBuilder = (loadingString: string) => () => (
  <FlexibleState
    data-ocweb-id={'loading-content'}
    mainText={loadingString}
    icon={<CircleLoader size="large" />}
    className={styles.driftError}
  />
)

export const driftEmptyStateBuilder = (
  emptyStateMainText: string,
  emptyStateSubText: React.ReactNode,
  component?: React.ReactNode
) => () => {
  return (
    <FlexibleState
      data-ocweb-id="NoAccountActivity"
      icon={<EmptyStateIcon />}
      mainText={emptyStateMainText}
      subText={emptyStateSubText}
      component={component}
    />
  )
}
